import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  color: var(--p-text-color);
}

dialog[open] {
  opacity: 1;
  visibility: visible;
}

dialog {
  opacity: 0;
  transition:
    opacity 0.3s ease-out,
    overlay 0.3s ease-out allow-discrete,
    display 0.3s ease-out allow-discrete;
  border: none;
  border-radius: var(--p-dialog-border-radius, 5px);
  width: var(--p-dialog-max-width, 650px);
  padding: 0;
  visibility: hidden;
  background-color: var(--p-bg);
}

@starting-style {
  dialog[open] {
    opacity: 0;
  }
}

dialog::backdrop {
  background-color: rgb(0 0 0 / 0%);
  transition:
    display 0.3s allow-discrete,
    overlay 0.3s allow-discrete,
    background-color 0.3s;
}

dialog[open]::backdrop {
  background-color: rgb(0 0 0 / 75%);
}

@starting-style {
  dialog[open]::backdrop {
    background-color: rgb(0 0 0 / 0%);
  }
}

/**
--------------------------------------------------
* Header
--------------------------------------------------
*/
.header {
  border-bottom: 1px solid var(--p-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .5rem .5rem .5rem 1rem;
}

h2 {
  font-family: var(--p-heading-font);
  font-weight: var(--p-h3-font-weight);
  font-style: var(--p-h3-font-style);
  line-height: 1;
  margin: 0;
  color: var(--p-text-color);
  font-size: var(--p-dialog-heading-font-size, 1rem);
}

/**
--------------------------------------------------
* Body
--------------------------------------------------
*/
.body {
  padding: 2rem;
}

@media (max-width: 768px) {
  .body {
    padding: 1rem;
  }
}


/**
--------------------------------------------------
* Footer
--------------------------------------------------
*/
.footer {
  padding: .75rem 1rem;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--p-border);
  gap: .5rem;
}


/**
--------------------------------------------------
* Drawer
--------------------------------------------------
*/
dialog.drawer {
  margin: 0 0 0 auto;
  border-radius: 0;
  min-height: 100svh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.drawer .body {
  flex-grow: 1;
  overflow-y: auto;
}

/**
--------------------------------------------------
* Full size
--------------------------------------------------
*/

.full-size {
  height: 100svh;
  max-height: 100vh;

  width: 100%;
  max-width: 100vw;
  /* max-height: 100vh; */
  margin: 0;
  padding:0;
  --p-dialog-border-radius: 0;

  display: flex;
  flex-direction: column;
  transition: none;
}

.full-size .body {
  height: 100%;
  padding: 0;
}

.full-size .footer {
  display: none;
}

`;
